import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

// Area Graph
const AreaGraph = ({ data, title, format, yAxisType }) => {
  let yAxisFormatter = function (val) {
    return format + val;
  };
  if (yAxisType === "time") {
    yAxisFormatter = function (totalSeconds) {
      const sign = totalSeconds < 0 ? "-" : "";
      const absSeconds = Math.abs(totalSeconds);

      const hours = Math.floor(absSeconds / 3600);
      const minutes = Math.floor((absSeconds % 3600) / 60);
      const seconds = absSeconds % 60;

      return sign + [
        hours.toString().padStart(2, "0"),
        minutes.toString().padStart(2, "0"),
        seconds.toString().padStart(2, "0")
      ].join(":");
    };
  }
  const [chartData, setChartData] = useState({
    series: [
      {
        name: title,
        data: [],
      },
    ],
    options: {
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          if (yAxisType === "time") {
            // reuse same logic as y-axis
            const sign = val < 0 ? "-" : "";
            const abs = Math.abs(val);
            const h = Math.floor(abs / 3600);
            const m = Math.floor((abs % 3600) / 60);
            const s = Math.floor(abs % 60);
            return sign + [h, m, s].map(n => n.toString().padStart(2, "0")).join(":");
          }
          return format + val;
        }
      },
      chart: {
        height: 250,
        type: "area",
      },
      xaxis: {
        categories: [],
        position: "top",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
          formatter: yAxisFormatter
        },
      },
      title: {
        text: title,
        align: "center",
        style: {
          color: "#444",
        },
      },
    },
  });

  // set the values for area graph based on props
  useEffect(() => {
    if (data?.recordcounts && data?.dates) {
      setChartData((prevGraphData) => ({
        ...prevGraphData,
        series: [
          {
            ...prevGraphData.series[0],
            data: data?.recordcounts,
            name: title
          },
        ],
        options: {
          ...prevGraphData.options,
          title: {
            ...prevGraphData.options.title,
            text: title,
          },

          xaxis: {
            ...prevGraphData.options.xaxis,
            categories: data?.dates
              ? data?.dates?.map((month) => month.slice(0, 3))
              : data?.recordcounts,
          },
        },
      }));
    }
  }, [data, title, format]);

  return (
    <ReactApexChart
      options={chartData.options}
      series={chartData.series}
      type="area"
      height={310}
    />
  );
};

export default AreaGraph;
